import { render } from "./AvatarEditor.vue?vue&type=template&id=bb85adae&scoped=true"
import script from "./AvatarEditor.vue?vue&type=script&lang=js"
export * from "./AvatarEditor.vue?vue&type=script&lang=js"

import "./AvatarEditor.vue?vue&type=style&index=0&id=bb85adae&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-bb85adae"

export default script